export const bscPresaleAddress = "0x2E49DA5942c178345786265181B1E746C55e765a";
export const bnbUsdtAddress = "0x55d398326f99059fF775485246999027B3197955";
export const bnbBusdAddress = "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56";
// export const bscPresaleAddress = "0x23Bc4aC55f68E315F9FB0D244b77503c0692491C"; // Testnet
// export const bnbUsdtAddress = "0x73445033cEA2d4b74c1c6119E1514da7B6a28739"; // Testnet
// export const bnbBusdAddress = "0x73445033cEA2d4b74c1c6119E1514da7B6a28739"; // Testnet
export const defaultAddress = "0x8cB348416fa6c8BFEDe3C5E52DADfD4EeEC93420";

